export default "/images/socialmedia_linkedin.png?8093f6efd2bf01bfcd49a23c6df0464d";